import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import LoadingOverlayWrapper from "react-loading-overlay-ts";
import variableStyles from "../../theme/variable-styles";

export const WorkflowManagementWrapper = styled(LoadingOverlayWrapper)(() => ({
  backgroundColor: "#ffffff",
  "& .workflow-header": {
    // backgroundColor: "white",
    height: 80,
    padding: "10px 15px 0px 0px",
    // position: "sticky",
    top: 0,
    // "z-index": 1,
    boxSizing: "border-box",
    "& .workflow-header-info": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between"
    },
    "& .workflow-icon": {
      width: "50px",
      textAlignLast: "center"
    },
    "& .workflow-title": {
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderRadius: 2
        }
      }
    },
    "& .name": {
      fontSize: "22px",
      inlineSize: "max-content"
    }
  },
  "& .workflow-tabs": {
    height: "calc(50% - 4px)",
    " & .tab-list": {
      li: {
        display: "inline",
        padding: "8px 0px",
        marginRight: "15px",
        " fontSize": "13px",
        cursor: "pointer",

        "&.active": {
          a: {
            color: "black"
          },
          color: variableStyles.MainColor,
          fontWeight: "bold",
          borderBottom: "solid 2px",
          borderColor: variableStyles.MainColor
        },
        a: {
          color: "#888"
        }
      }
    }
  }
}));

// Wrapper tổng
export const DashboardWrapper = styled(Box)(() => ({
  display: "flex",
  gap: "20px",
  padding: "20px",
  backgroundColor: "#ffffff",
  height: "100%",
  overflow: "auto",
  "&.active": {
    cursor: "grabbing"
  }
}));

// Cột chứa card
export const ColumnWrapper = styled(Box)(() => ({
  background: "#F7F7F7",
  borderRadius: "12px",
  padding: "12px",
  flex: "0 0 250px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
  height: "fit-content"
}));

// Header của cột
export const ColumnHeader = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "12px",
  gap: 12
}));

export const ColumnTitle = styled("span")(() => ({
  fontWeight: 600,
  fontSize: "14px",
  gap: "6px"
}));

export const ColumnImgLeft = styled("img")(() => ({
  fontWeight: 600,
  fontSize: "14px",
  gap: "6px"
}));

export const ColumnImgRight = styled("img")(() => ({
  fontWeight: 600,
  fontSize: "14px",
  gap: "6px"
}));

export const AddBtn = styled("button")(() => ({
  background: "#00c853",
  border: "none",
  borderRadius: "50%",
  color: "#fff",
  width: "24px",
  height: "24px",
  cursor: "pointer",
  marginLeft: "auto"
}));

// Card nhiệm vụ
export const TaskCardWrapper = styled(Box)(() => ({
  background: "#fff",
  borderRadius: "10px",
  padding: "12px",
  marginBottom: "10px",
  cursor: "pointer"
}));

export const CardTitle = styled("div")(() => ({
  fontSize: "13px",
  fontWeight: 500,
  marginBottom: "8px"
}));

export const CardNumber = styled("div")(() => ({
  fontSize: "22px",
  fontWeight: "bold"
}));

export const CardSubtitle = styled("div")(() => ({
  fontSize: "12px",
  color: "#777"
}));

export const CardStatus = styled(Box)(() => ({
  marginTop: "8px",
  display: "flex",
  gap: "8px"
}));

export const Done = styled("span")(() => ({
  background: "#e0f7e9",
  color: "#00c853",
  padding: "2px 8px",
  borderRadius: "8px",
  fontSize: "12px"
}));

export const Fail = styled("span")(() => ({
  background: "#f5f5f5",
  color: "#888",
  padding: "2px 8px",
  borderRadius: "8px",
  fontSize: "12px"
}));

export const FailNumber = styled("span")(() => ({
  fontWeight: "bold"
}));

export const Success = styled("span")(() => ({
  background: "#E2FDE8",
  color: "#26BF6A",
  padding: "2px 8px",
  borderRadius: "8px",
  fontSize: "12px"
}));

export const SuccessNumber = styled("span")(() => ({
  fontWeight: "bold"
}));
